module.exports = __webpack_public_path__ + "static/media/10.a0978778.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/10.png
// module id = 969
// module chunks = 0